module.exports = __webpack_public_path__ + "img/gbattle.83c4e07.webp";